import React, { Component } from "react";
import dayjs from "dayjs";
import numeral from "numeral";
import _ from "lodash";
import { withRouter } from "react-router-dom";

import { withRedux } from "../../hoc";

const mapStateToProps = ({ language, t }) => {
  return {
    language,
    t,
  };
};

@withRouter
@withRedux(mapStateToProps)
class Summary extends Component {
  getTableSummary = () => {
    const { t, selectedData } = this.props;
    const groupTypes = _.groupBy(selectedData, "seatType");

    if (!selectedData) return null;

    return _.map(groupTypes, (item, key) => {
      return (
        <tr key={key}>
          <td className="seat-name-block">
            <p className="seat-name">{key}</p>
            <p>
              {t("No")}. :
              {_.map(item, (value, key) => {
                return (
                  <span key={key} className="seat-number">
                    {_.get(value, "seatNumber")}
                  </span>
                );
              })}
            </p>
          </td>
          <td className="seat-price-block">
            <p>
              {numeral(_.sumBy(item, "price")).format("0,0")} {t("THB")}
            </p>
          </td>
        </tr>
      );
    });
  };

  getFoodSummary = () => {
    const { t, selectedFoods } = this.props;
    const groupBy = _.groupBy(selectedFoods, "itemID");
    if (!selectedFoods) return null;
    return _.map(groupBy, (item, key) => {
      const title = _.get(item, [0, "title"]);
      return (
        <tr className="border-none" key={key}>
          <td className="food-name-block">
            <p className="food-name">{`${t(title)} x${_.size(item)}`}</p>
          </td>
          <td className="food-price-block">
            <p>
              {numeral(_.sumBy(item, "price")).format("0,0")} {t("THB")}
            </p>
          </td>
        </tr>
      );
    });
  };

  render() {
    const {
      t,
      selectedData,
      selectedFoods,
      selectedShowtime,
      selectedDate,
    } = this.props;

    const total = _.sumBy(selectedData, "price");
    const foodTotal = _.sumBy(selectedFoods, "price");
    const time = dayjs(_.get(selectedShowtime, "showTime")).format("H:mm");
    const date = dayjs(selectedDate).format("DD MMM YYYY");
    const grandTotal = total + foodTotal;
    return (
      <div className="container-summary">
        <div className="container-selected-summary">
          <h2>{t("Summary")}</h2>
          <div className="row">
            <div className="col-md-4">
              <div className="item item-showtime">
                <p className="title">{t("Date & Showtime")}</p>
                <p>
                  <i className="fa fa-calendar" />
                  {date}
                </p>
                <p>
                  <i className="fa fa-clock-o" />
                  {time}
                </p>
              </div>
            </div>
            <div className="col-md-8">
              <div className="item">
                <table className="color-border">
                  <tbody>
                    <tr>
                      <th>{t("Seat Number")}</th>
                      <th>{t("Price")}</th>
                    </tr>
                    {this.getTableSummary()}
                  </tbody>
                </table>
              </div>
              <div className="total-price">
                {/* <h3>{t("Total Price")}</h3>
                <h3>
                  <span>{numeral(total).format("0,0")}</span> {t("THB")}
                </h3> */}
                <table className="total-border">
                  <tbody>
                    <tr>
                      <th>{t("Total Price")}</th>
                      <th>
                        <span>{numeral(total).format("0,0")}</span> {t("THB")}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="item">
                <table>
                  <tbody>
                    <tr>
                      <th>{t("FOOD & DRINKS")}</th>
                      <th>{t("Price")}</th>
                    </tr>
                    {this.getFoodSummary()}
                  </tbody>
                </table>
              </div>
              <div className="total-price last">
                <table className="total-border">
                  <tbody>
                    <tr>
                      <th>{t("Total Price")}</th>
                      <th>
                        <span>{numeral(foodTotal).format("0,0")}</span>{" "}
                        {t("THB")}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="total-price">
                <h3>{t("Grand total")}</h3>
                <h3>
                  <span>{numeral(grandTotal).format("0,0")}</span> {t("THB")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/pages/Booking/Summary.js